import React, { useReducer } from "react";
import EntryAndDepartureReportReducer from "./EntryAndDepartureReportReducer";
import EntryAndDepartureReportContext from "./EntryAndDepartureReportContext";
import { t } from "i18next";
import { downloadEntryAndDepartureReportService, editEntryOrDepartureService, getEntriesAndDeparturesService, getResourceDetailToReportService, downloadEntryAndDepartureReportServicePDF } from "../../services/reports";
import { logout } from "../../services/login";
import { getDataUserByKey, getUserBuilding, getUserOpening } from "../../helpers/helpers";

const EntryAndDepartureReportState = ({ children }) => {

    const initialState = {
        entriesAndDepartures: [],
        entriesAndDeparturesPaginated: [],
        resourceDetail: {},
        filters: {
            date_from: '',
            date_to: '',
            resource_type: [],
            contractors: [],
            search_text: '',
            opening_code: [],
            user_created: [],
            permanence_time_from: 0,
            permanence_time_to: null,
            column_order: 'name',
            order_type: 'DESC',
            buildings: [],
            areas: [],
            in_plant: true,
            reg_from: 1,
            page_length: 10
        },
        totalPages: null,
        page: 1,
        changePage: false,
        isFetching: true,
        tableHeaders: [
            { key: ('RES'), columnOrder: 'name', order: 'DESC', active: true },
            { key: ('ENTRY'), columnOrder: 'entry_date', order: 'DESC', active: false },
            { key: ('DEPARTURE'), columnOrder: 'egress_date', order: 'DESC', active: false },
            { key: ('TIME_ELAPSED'), columnOrder: 'seconds', order: 'DESC', active: false },
            { key: ('TYPE'), columnOrder: 'resource_type', order: 'DESC', active: false },
            { key: ('CONTRACTOR'), columnOrder: 'contractor_name', order: 'DESC', active: false },
            { key: '' },
        ],
        error: {
            ok: false,
            text: ''
        },
        isDownloadingReport: false,
        exportTypes: [
            { name: 'Excel', code: 'xls' },
            { name: 'PDF', code: 'pdf' },
        ],
    }

    const [state, dispatch] = useReducer(EntryAndDepartureReportReducer, initialState);

    const getResourceDetailToReport = async (query) => {
        try {
            const { access_resource_id, resource_type } = query;

            const queryToReq = access_resource_id || resource_type ? `access_resource_id=${access_resource_id}&resource_type=${resource_type}` : '';

            const resData = await getResourceDetailToReportService(queryToReq);

            if (resData.ok) {
                dispatch({
                    type: 'SET_RESOURCE_DETAIL',
                    payload: {
                        resourceDetail: resData.data.response,
                        error: {
                            ok: false,
                            text: ''
                        }
                    }
                })

            } else {
                let errorMsg;
                switch (resData.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'SET_RESOURCE_DETAIL',
                    payload: {
                        resourceDetail: state.resourceDetail,
                        error: {
                            ok: true,
                            text: errorMsg
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'SET_RESOURCE_DETAIL',
                payload: {
                    resourceDetail: state.resourceDetail,
                    error: {
                        ok: true,
                        text: t('SERVER_ERROR')
                    }
                }
            });
        }
    }

    const setFilters = (filter) => {
        dispatch({
            type: 'SET_FILTERS',
            payload: filter
        });
    }

    const getEntriesAndDepartures = async (newFilter) => {
        try {
            const isGuard = getDataUserByKey('access_profile_id') === '3';
            const haveSelectedAnAccessOpening = getUserOpening().descripcion !== t('NO_OPENING');
            const haveSelectedAnAccessBuilding = getUserBuilding().buildingDescription !== t('NO_BUILDING');

            setFilters(newFilter);

            const filterToSend = {
                ...newFilter,
                ...((isGuard && haveSelectedAnAccessOpening) && { opening_code: [getUserOpening().codigo] }),
                ...((isGuard && haveSelectedAnAccessBuilding) && { buildings: [getUserBuilding().buildingId] }),
                ...(newFilter.date_from && { date_from: newFilter.date_from.replaceAll('-', '') }),
                ...(newFilter.date_to && { date_to: newFilter.date_to.replaceAll('-', '') })
            };

            const items = await getEntriesAndDeparturesService(filterToSend);

            if (items.ok) {
                dispatch({
                    type: 'GET_ENTRIES_AND_DEPARTURES',
                    payload: {
                        entriesAndDepartures: items.data.response.movements,
                        totalPages: items.data.response.total_pages,
                        error: {
                            ok: false,
                            text: ''
                        }
                    }
                })

            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'MAX_DATE_RANGE_ERROR':
                        errorMsg = t('DATE_RANGE_CANT_BE_MORE_THAN_ONE_YEAR');
                        break;
                    case 'FUTURE_DATE':
                        errorMsg = t('DATE_RANGE_CANT_BE_FUTURE');
                        break;
                    case 'DATE_ERROR':
                        errorMsg = t('DATE_SINCE_CANT_BE_MORE_THAN_UNTIL_DATE');
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'GET_ENTRIES_AND_DEPARTURES',
                    payload: {
                        entriesAndDepartures: state.entriesAndDeparturesPaginated,
                        error: {
                            ok: true,
                            text: errorMsg
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'GET_ENTRIES_AND_DEPARTURES',
                payload: {
                    entriesAndDepartures: state.entriesAndDeparturesPaginated,
                    error: {
                        ok: true,
                        text: t('SERVER_ERROR')
                    }
                }
            });
        }
    }

    const downloadEntriesAndDeparturesReport = async (exportType) => {
        try {

            dispatch({ type: 'DOWNLOADING', payload: true });

            const filterToSend = {
                ...state.filters,
                ...(state.filters.date_from && { date_from: state.filters.date_from.replaceAll('-', '') }),
                ...(state.filters.date_to && { date_to: state.filters.date_to.replaceAll('-', '') })
            };

            // Elegir servicio según tipo
            const service =
                exportType === 'pdf'
                    ? downloadEntryAndDepartureReportServicePDF
                    : downloadEntryAndDepartureReportService;

            const response = await service(filterToSend);

            if (response.ok) {

                const link = document.createElement("a");

                link.target = "_blank";

                link.download = `${t('ENTRY_DEPARTURE')}_${state.filters.date_from} - ${state.filters.date_to}`

                link.href = URL.createObjectURL(new Blob([response.data], { type: response.data.type }));

                link.click();

                dispatch({ type: 'DOWNLOADING', payload: false });

            } else {

                const errorType = await response.data.json();

                switch (errorType.error_code) {

                    case 'AUTH_ERROR':
                        dispatch({
                            type: 'DOWNLOAD_ENTRY_AND_DEPARTURE_REPORT',
                            payload: {
                                ok: true,
                                text: t('TOKEN_ERROR')
                            }
                        });
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;

                    case 'PROFILE_ACCESS_ERROR':
                        dispatch({
                            type: 'DOWNLOAD_ENTRY_AND_DEPARTURE_REPORT',
                            payload: {
                                ok: true,
                                text: t('PERMISSIONS_ERROR')
                            }
                        });
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;

                    case 'MAX_DATE_RANGE_ERROR':
                        dispatch({
                            type: 'DOWNLOAD_ENTRY_AND_DEPARTURE_REPORT',
                            payload: {
                                ok: true,
                                text: t('DATE_RANGE_CANT_BE_MORE_THAN_ONE_YEAR')
                            }
                        });
                        break;
                    case 'FUTURE_DATE':
                        dispatch({
                            type: 'DOWNLOAD_ENTRY_AND_DEPARTURE_REPORT',
                            payload: {
                                ok: true,
                                text: t('DATE_RANGE_CANT_BE_FUTURE')
                            }
                        });
                        break;
                    case 'DATE_ERROR':
                        dispatch({
                            type: 'DOWNLOAD_ENTRY_AND_DEPARTURE_REPORT',
                            payload: {
                                ok: true,
                                text: t('DATE_SINCE_CANT_BE_MORE_THAN_UNTIL_DATE')
                            }
                        });
                        break;


                    default:
                        dispatch({
                            type: 'DOWNLOAD_ENTRY_AND_DEPARTURE_REPORT',
                            payload: {
                                ok: true,
                                text: t('ERROR_TRY_AGAIN')
                            }
                        });
                        break;

                }

                dispatch({ type: 'DOWNLOADING', payload: false });

            }


        } catch (e) {
            console.log(e)
            dispatch({
                type: 'DOWNLOAD_ENTRY_AND_DEPARTURE_REPORT',
                payload: {
                    ok: true,
                    text: t('ERROR_TRY_AGAIN')
                }
            });
        }
    }

    const setTableHeaders = (headers) => {
        dispatch({
            type: 'SET_TABLE_HEADERS',
            payload: headers
        })
    }
    const changingPage = () => {
        dispatch({
            type: 'CHANGE_PAGE',
        });
    }
    const setPage = (page) => {
        dispatch({
            type: 'SET_PAGE',
            payload: page
        })
    }
    const cleanErrorMsg = () => {
        dispatch({
            type: 'SET_ERROR',
            payload: {
                ok: false,
                text: ''
            }
        })
    }
    const cleanEntryAndDepartureFilters = () => {
        dispatch({
            type: 'CLEAN_FILTERS',
            payload: {
                date_from: '',
                date_to: '',
                resource_type: [],
                contractors: [],
                search_text: '',
                opening_code: [],
                user_created: [],
                permanence_time_from: 0,
                permanence_time_to: null,
                column_order: 'name',
                order_type: 'DESC',
                buildings: [],
                in_plant: true,
                reg_from: 1,
                page_length: 10
            }
        })
    }
    const setChangeFetching = () => {
        dispatch({
            type: 'SET_CHANGE_FETCHING',
            payload: !state.isFetching
        })
    }

    const editEntryOrDeparture = async (values) => {
        try {

            const resData = await editEntryOrDepartureService(values);

            if (resData.ok) {

                return {
                    ok: resData.data.response,
                    message: ''
                };

            } else {
                switch (resData.data.error_code) {
                    case 'PARAM_ERROR':

                        return {
                            ok: false,
                            message: t('ERROR_TRY_AGAIN')
                        }

                    case 'AUTH_ERROR':

                        setTimeout(() => {
                            logout();
                        }, 1000);

                        return {
                            ok: false,
                            message: t('TOKEN_ERROR')
                        }

                    case 'DATE_ERROR':
                        return {
                            ok: false,
                            message: t('INVALID_DATE_MODIFICATION')
                        }

                    default:
                        return {
                            ok: false,
                            message: t('ERROR_TRY_AGAIN')
                        }
                }

            }
        } catch (e) {
            console.log(e)
            return {
                ok: false,
                message: t('SERVER_ERROR')
            }
        }
    }

    return (
        <EntryAndDepartureReportContext.Provider
            value={{
                entryAndDepartureReportState: state,
                getEntriesAndDepartures,
                setFilters,
                changingPage,
                setTableHeaders,
                setPage,
                getResourceDetailToReport,
                setChangeFetching,
                downloadEntriesAndDeparturesReport,
                cleanErrorMsg,
                cleanEntryAndDepartureFilters,
                editEntryOrDeparture
            }}>
            {children}
        </EntryAndDepartureReportContext.Provider>
    )
}

export default EntryAndDepartureReportState